import React, { Fragment, PropsWithChildren } from 'react';

import './modal.scss';

type Props = {
  show: boolean;
};

const Modal = ({ show, children }: PropsWithChildren<Props>) => {
  if (!show) return <Fragment />;

  return (
    <div className="modal">
      <div className="modal__content">{children}</div>
    </div>
  );
};

export default Modal;
